import { listMyBands } from './bandsApi';
import { listCloudBandSongs, type CloudSongRecord } from './songSync';
import { appStore } from './store';
import { addSyncDiagnostic } from './syncDiagnostics';

export async function syncCloudLibraryMetadata(): Promise<{ addedSongs: number; updatedSongs: number; createdSetlist: boolean; duplicateCloudSongs: number; remappedSetlistEntries: number; error: string | null }> {
  const bandsResult = await listMyBands();
  if (bandsResult.error) {
    addSyncDiagnostic({
      level: 'error',
      source: 'cloud-library-pull',
      message: 'Could not list Cloud Bands.',
      details: { error: bandsResult.error },
    });
    return { addedSongs: 0, updatedSongs: 0, createdSetlist: false, duplicateCloudSongs: 0, remappedSetlistEntries: 0, error: bandsResult.error };
  }
  addSyncDiagnostic({
    level: 'info',
    source: 'cloud-library-pull',
    message: 'Listed Cloud Bands for signed-in user.',
    details: {
      bandCount: bandsResult.bands.length,
      bandIds: bandsResult.bands.map((band) => band.id).join(', '),
      bandNames: bandsResult.bands.map((band) => band.name).join(', '),
    },
  });

  const cloudSongs: CloudSongRecord[] = [];
  for (const band of bandsResult.bands) {
    const songsResult = await listCloudBandSongs(band.id);
    if (songsResult.error) {
      addSyncDiagnostic({
        level: 'error',
        source: 'cloud-library-pull',
        message: 'Could not list cloud songs for a Cloud Band.',
        details: { bandId: band.id, bandName: band.name, error: songsResult.error },
      });
      return { addedSongs: 0, updatedSongs: 0, createdSetlist: false, duplicateCloudSongs: 0, remappedSetlistEntries: 0, error: songsResult.error };
    }
    addSyncDiagnostic({
      level: 'info',
      source: 'cloud-library-pull',
      message: 'Pulled cloud song metadata for one band.',
      details: {
        bandId: band.id,
        bandName: band.name,
        cloudSongCount: songsResult.songs.length,
        cloudSongIds: songsResult.songs.map((song) => song.id).join(', '),
        cloudSongNames: songsResult.songs.map((song) => song.name).join(', '),
        markerClientIdSummary: songsResult.songs.map((song) => `${song.id}:${song.markers.map((marker) => marker.id).join('|')}`).join(', '),
      },
    });
    cloudSongs.push(...songsResult.songs);
  }

  const result = await appStore.upsertCloudLibraryMetadata(bandsResult.bands, cloudSongs);
  addSyncDiagnostic({
    level: 'info',
    source: 'cloud-library-pull',
    message: 'Merged cloud song metadata into this device.',
    details: {
      cloudSongCount: cloudSongs.length,
      addedSongs: result.addedSongs,
      updatedSongs: result.updatedSongs,
      createdSetlist: result.createdSetlist,
      duplicateCloudSongs: result.duplicateCloudSongs,
      remappedSetlistEntries: result.remappedSetlistEntries,
    },
  });
  return { ...result, error: null };
}
